import "./GameClosed.scss";

export const GameClosed = () => {

  const handleBackLobby = () => {
    window.location.reload();
  };
  return (
    <div className="GameClosed">
      <h2> Game closed because not everyone was ready!</h2>
      <button onClick={handleBackLobby}>Back to the lobby</button>
    </div>
  );
};
export default GameClosed;
